import { PageSettings, ResourceService } from "@/services/resource";
import { MediaSlotTypeMap } from "@/util/constants";
import { MediaSlot, MediaType } from "@/util/enum";
import MediaViewer from "@/views/text-guardian/sub-views/title-list/sub-views/media/sub-views/component/media-viewer/media-viewer.vue";
import IMediaViewer from "@/views/text-guardian/sub-views/title-list/sub-views/media/sub-views/component/media-viewer/media-viewer";
import { Modal } from "ant-design-vue";
import { Component, Ref, Vue } from "vue-property-decorator";
import { delay } from "lodash";
import { PhonogramSaveModel, PhonogramType } from "@/models/phonogram-manager-model";

@Component({
	components: {
		Modal,
		MediaViewer
	}
})
export default class PdfPagesViewer extends Vue {
	@Ref("mediaViewerRef") mediaViewerRef!: IMediaViewer;

	public props: Partial<PdfPagesViewerProps> = {};
	public visible: boolean = false;
	public isDirty: boolean = false;
	public loading: boolean = false;
	public data: Partial<PhonogramSaveModel> = {};

	public open(props: PdfPagesViewerProps, phonogram?: PhonogramSaveModel) {
		if (phonogram) {
			this.data = phonogram;
		}
		this.visible = true;
		this.props = props;
	}

	public close() {
		this.visible = false;
		delay(() => {
			this.props = {};
		}, 500);
	}

	public async save() {
		this.loading = true;

		const pageSettings: PageSettings[] = this.mediaViewerRef.pages.pageImages.map((page) => {
			return { pageId: page.id, teacherUseOnly: page.teacherUseOnly };
		});

		if (this.data.phonogramTypeId == PhonogramType.Card) {
			await ResourceService.savePageSettings(pageSettings, this.data.name);
		} else if (this.data.phonogramTypeId == PhonogramType.WordCard) {
			await ResourceService.savePageSettings(pageSettings, undefined, this.data.name);
		} else {
			await ResourceService.savePageSettings(pageSettings);
		}

		this.onMediaViewerClose();
	}

	onMediaViewerClose() {
		this.loading = false;
		this.isDirty = false;
		this.visible = false;
	}

	public get isMediaTypePNG() {
		if (this.props.mediaSlotId) {
			const mediaType = MediaSlotTypeMap[this.props.mediaSlotId];
			if (mediaType === MediaType.PNG) {
				return null;
			}
		}
	}

	public get isMediaAlternateContent() {
		if (this.props.mediaSlotId) {
			if (this.props.mediaSlotId === MediaSlot.AlternateContent) {
				return true;
			}
			return false;
		}
	}

	public isModalDirty(event) {
		this.isDirty = event.isDirty;
	}
}

export interface PdfPagesViewerProps {
	mediaId: string;
	mediaSlotId: MediaSlot;
	isPage?: boolean;
	isShowAdditionalData?: boolean;
}
